import React from 'react';
import Card from '../../../components/Card';
import data from './data';
import './services.css';

const Services = () => {
  return (
    <section id="services" className="dummy-services-section">
      <h2 className="section-title">What SkillBridge Delivers</h2>
      <p className="section-para">Outcome-first training, internship experience and career mentorship tailored for the UK job market.</p>
      <div className="container services__container" data-aos="fade-up">
        {
          data.map(item => (
            <Card key={item.id} className="service-card-item">
              <div className="service-card-icon">{item.icon}</div>
              <div className="service-card-details">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </Card>
          ))
        }
      </div>
    </section>
  );
};

export default Services;